import React, { useEffect, useRef, useState } from "react";

/** Libraries */
import { Col, Container, Row } from "react-bootstrap";
import { m } from "framer-motion";
import { useForm } from "react-hook-form";
import { ToastContainer, toast } from "react-toastify";
import { useLocation } from "react-router-dom";

/** Components */
import { fadeIn } from "../../Functions/GlobalAnimations";
import Buttons from "../../Components/Button/Buttons";

/** style */
import "../../../Assets/scss/MedicalCounsellingIndia/pages/home.scss";
import CommonContactButton from "../../Components/AnotherButton/CommonContactButton";
import MetaTags from "../../Components/MetaTags";
import "./DirectAdmissionInBptInPune.scss";

/** top college details */

function MbaAdmissionCounsellingIndia() {
  const [formLoading, setFormLoading] = useState(false);
  const collegeSectionRef = useRef(null);
  const location = useLocation();

  // const collegeTitle = collegeName
  // .split("-")
  // .map((curElem) => {
  //   if (exceptions.includes(curElem)) return curElem;
  //   return curElem.charAt(0).toUpperCase() + curElem.slice(1);
  // })
  // .join(" ");

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: "all" });

  const onSubmit = (data) => {
    console.log(data);
    setFormLoading(true);
    toast.success("Your message has been sent successfully!", {
      theme: "colored",
    });

    setTimeout(() => {
      setFormLoading(false);
    }, 1000);
  };

  const handleKeyDown = (event) => {
    const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight"];
    const isNumberKey = !isNaN(Number(event.key)) && event.code !== "Space";

    if (!allowedKeys.includes(event.code) && !isNumberKey) {
      event.preventDefault();
    }
  };

  /** scroll to college */

  useEffect(() => {
    if (
      location.search.includes("scrollToCollege=true") &&
      collegeSectionRef.current
    ) {
      collegeSectionRef.current.scrollIntoView({ behavior: "smooth" });
      console.log("hi");
    }
  }, [location.search]);

  return (
    <>
      <MetaTags
        title="MBA Admission 2026 Guidance | Counselling India"
        description="Get expert MBA Admission 2026 guidance from Counselling India. Top colleges admission support available. Call now: 9730858444."
        keywords="MBA Admissions Counselling India  in 2026"
      />

      {/* banner Parallax Scrolling End */}

      {/* instruction section start  */}
      <section className="bg-lightgray py-[150px] pb-[100px] lg:py-[50px]  md:py-[80px] md:pb-[120px]  sm:py-[100px]">
        <Container>
          {/* How to get Admission */}
          <div className="">
            <div>
              <div className="!text-[#616162] mt-4  ">
                <h1 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-normal">
                  MBA Admissions Consultant – Counselling India
                </h1>
                <div className="mt-3">
                  In today’s fast-paced, competitive world, earning an MBA from
                  a reputed institute has become essential for career
                  advancement, leadership roles, and entrepreneurship. However,
                  gaining admission into top business schools in India is no
                  easy feat. With limited seats, intense entrance exams, and
                  complicated procedures, many deserving students often struggle
                  to find their path. That’s where <b>Counselling India,</b> a
                  leading <b>MBA admissions consultant,</b> steps in to make a
                  real difference.
                </div>
              </div>
            </div>
          </div>

          <div className="mt-5">
            <CommonContactButton />
          </div>

          {/* general eligibility */}

          <div className="mt-[50px]">
            <h2 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-none">
              Who We Are
            </h2>
            <div>
              <p className="!text-[#616162]">
                Counselling India is one of the most trusted names in MBA
                admission consulting, with over 20 years of experience in
                guiding students through the complexities of the management
                education landscape. As a dedicated MBA admissions consultant,
                we offer personalized services to help you get into India's top
                MBA colleges through various channels, including entrance-based
                admission, management quota, and NRI quota.
              </p>
              <p className="mt-3">
                With a success-driven approach and student-first philosophy, we
                have helped thousands of students fulfill their dream of
                studying MBA in institutes across cities like Bangalore, Pune,
                Mumbai, Delhi, Chennai, and Hyderabad.
              </p>
            </div>
          </div>

          <div className="mt-[50px]">
            <h2 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-none">
              Why Choose Counselling India?
            </h2>
            <div>
              <p className="!text-[#616162]">
                Choosing the right MBA admissions consultant can be the most
                critical step in your MBA journey. At Counselling India, we
                provide more than just information — we offer insight,
                direction, and actionable support. Here’s why students and
                parents trust us:
              </p>
              <ol className="!text-[#616162] mt-4 ml-10  md:ml-5 list-disc">
                <li>
                  <div>
                    <b>1. Experienced Consultants</b>
                  </div>

                  <div>
                    Choosing the right MBA admissions consultant can be the most
                    critical step in your MBA journey. At Counselling India, we
                    provide more than just information — we offer insight,
                    direction, and actionable support. Here’s why students and
                    parents trust us:
                  </div>
                </li>
                <li className="mt-3">
                  <div>
                    <b>2. Personalized Counseling)</b>
                  </div>

                  <div>
                    Each student is different. Our one-on-one counseling
                    sessions ensure your academic profile, career goals,
                    financial budget, and preferred location are carefully
                    considered before recommending colleges.
                  </div>
                </li>
                <li className="mt-3">
                  <div>
                    <b>3. Admission Through Management Quota</b>
                  </div>
                  <p>
                    Not everyone scores high on entrance exams like CAT, MAT,
                    XAT, or CMAT. But that shouldn't stop you. We specialize in
                    MBA admission through management quota and can help secure
                    seats in reputed private and deemed universities
                  </p>
                </li>
                <li className="mt-3">
                  <div>
                    <b>4. Transparent Process</b>
                  </div>
                  <p>
                    We believe in ethical consulting. There are no hidden
                    charges or misleading claims. Our admissions process is 100%
                    transparent, and all payments are made directly to the
                    colleges.
                  </p>
                </li>
                <li className="mt-3">
                  <div>
                    <b>5. End-to-End Support</b>
                  </div>
                  <p>
                    From form filling and document submission to college
                    follow-ups and interview prep, we manage everything for you.
                    Our goal is to make your admission process stress-free and
                    result-oriented.
                  </p>
                </li>
              </ol>
            </div>
          </div>

          <div className="mt-[50px]">
            <h2 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-none">
              Our MBA Admission Services
            </h2>
            <div>
              <p className="!text-[#616162]">
                As a leading MBA admissions consultant, we offer comprehensive
                services for students seeking admission into top MBA programs
                across India. Here’s what we provide:
              </p>
            </div>
            <div>
              <ol className="!text-[#616162] mt-4 ml-10  md:ml-5 ">
                <li>
                  <b>A. College Shortlisting</b>
                  <p>
                    With hundreds of MBA colleges available, making the right
                    choice can be overwhelming. We help you shortlist institutes
                    based on ranking, specialization, budget, ROI, and location
                    preference.
                  </p>
                </li>
                <li className="mt-2">
                  <b>B. Application Assistance</b>
                  <p>
                    We assist in filling out college application forms, ensuring
                    accuracy and timely submission. Our experts help present
                    your academic and professional background in the most
                    impactful way.
                  </p>
                </li>

                <li className="mt-2">
                  <b>C. Admission Through Management/NRI Quota</b>
                  <p>
                    We have strong connections with reputed private colleges
                    that reserve seats under the management quota and NRI quota.
                    Our guidance ensures smooth and timely admissions without
                    hassles.
                  </p>
                </li>
                <li>
                  <b>D. Documentation Support</b>
                  <p>
                    We provide a checklist and help organize all required
                    documents, such as mark sheets, ID proof, graduation
                    certificates, and entrance exam scorecards (if applicable)
                  </p>
                </li>
                <li>
                  <b>E. Interview Preparation</b>
                  <p>
                    Many top MBA colleges conduct personal interviews before
                    granting admission. Our consultants conduct mock interviews
                    and provide tips to help you build confidence and clarity.
                  </p>
                </li>
                <li>
                  <b>F. Post-Admission Services</b>
                  <p>
                    Once your admission is confirmed, we guide you through fee
                    payment, hostel booking, scholarship application (if
                    applicable), and orientation support.
                  </p>
                </li>
              </ol>
            </div>
          </div>

          <div className="mt-[50px]">
            <h2 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-none">
              Top MBA Colleges We Work With
            </h2>
            <p>
              We’ve helped students secure admissions into some of India’s top
              business schools. As your MBA admissions consultant, we assist
              with direct and management
            </p>

            <div>
              <ol className="!text-[#616162] mt-4 ml-10  md:ml-5 list-disc">
                <li>
                  <b>
                    Symbiosis Institute of Business Management (Pune, Bangalore)
                  </b>
                </li>
                <li>
                  <b>Christ University (Bangalore)</b>
                </li>
                <li>
                  <b>NMIMS (Mumbai, Hyderabad, Bangalore)</b>
                </li>
                <li>
                  <b>
                    Xavier Institute of Management and Entrepreneurship
                    (XIME){" "}
                  </b>
                </li>

                <li>
                  <b>Jain University (Bangalore)</b>
                </li>
                <li>
                  <b>Amity Business School (Noida)</b>
                </li>
                <li>
                  <b>ICFAI Business School (Hyderabad and pan-India)</b>
                </li>
                <li>
                  <b>PES University (Bangalore)</b>
                </li>
                <li>
                  <b>ISBR Business School (Bangalore)</b>
                </li>
              </ol>
              <p>
                We also assist with emerging B-schools known for specific
                industry-focused MBA programs and excellent ROI.
              </p>
            </div>
          </div>

          <div className="mt-[50px]">
            <h2 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-none">
              Management Quota MBA Admission – A Viable Route
            </h2>
            <p>
              Many students wrongly assume that MBA admission through management
              quota is for academically weak candidates or those with large
              financial backing. The reality is different.
            </p>
            <p className="mt-2">
              Management quota admission is a legitimate and government-approved
              process, especially in private or deemed universities. It is
              designed for:
            </p>

            <div>
              <ol className="!text-[#616162] mt-4 ml-10  md:ml-5 list-disc">
                <li>Students who missed the cutoff by a narrow margin</li>{" "}
                <li>
                  Professionals looking for executive MBA without lengthy
                  entrance procedures
                </li>
                <li>
                  Candidates seeking admission in a specific city or college due
                  to personal constraints
                </li>
              </ol>

              <p className="mt-3">
                At <b>Counselling India,</b> we demystify this process and
                ensure fair and quick admission to deserving students through
                this route.
              </p>
            </div>
          </div>

          <div className="mt-[50px]">
            <h2 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-none">
              Specializations Available
            </h2>
            <div>
              <p className="!text-[#616162]">
                We guide students toward MBA programs in high-demand
                specializations such as:
              </p>
            </div>

            <div>
              <ol className="!text-[#616162] mt-4 ml-10  md:ml-5 list-disc">
                <li>Marketing</li>
                <li>Finance</li>
                <li>Human Resource Management</li>
                <li>Business Analytics</li>
                <li>Information Technology</li>
                <li>Operations & Supply Chain</li>
                <li>Healthcare Management</li>
                <li>Agri-business and more </li>
              </ol>
              <p>
                Our counselors help you choose a specialization aligned with
                your career aspirations and market demand.
              </p>
            </div>
          </div>

          <div className="mt-[50px]">
            <h2 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-none">
              Who Can Approach Us?
            </h2>
            <div>
              <p className="!text-[#616162]">Our services are ideal for:</p>
            </div>

            <div>
              <ol className="!text-[#616162] mt-4 ml-10  md:ml-5 list-disc">
                <li>
                  Final-year undergraduate students looking for full-time MBA
                  admission
                </li>
                <li>
                  Working professionals aiming for part-time or executive MBA
                </li>
                <li>
                  Students aiming for direct admission in top private MBA
                  colleges
                </li>
                <li>
                  International and NRI students looking for guidance under NRI
                  quota
                </li>
              </ol>
              <p>
                No matter your background, we ensure you’re guided toward the
                best available MBA opportunities.
              </p>
            </div>
          </div>

          <div className="mt-[50px]">
            <h2 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-none">
              Testimonials
            </h2>
            <p className="w-50">
              “Counselling India made my MBA journey seamless. I had missed the
              CAT cut-off, but they helped me secure a seat at a top B-school
              through management quota. Very professional and supportive team!”
              <b className="fst-italic">— Rohit S., Pune</b>
            </p>

            <p className="mt-5 w-50">
              “They helped me shortlist the best colleges for HR specialization
              and guided me throughout the process. Highly recommended MBA
              admissions consultant.”
              <b className="fst-italic"> — Megha T., Delhi</b>
            </p>
          </div>

          <div className="mt-[50px]">
            <h2 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-none">
              Final Thoughts
            </h2>

            <div>
              Choosing the right MBA admissions consultant can significantly
              affect your career. With Counselling India, you’re not just
              getting an admission guide—you’re getting a committed partner in
              your success. Whether you’re targeting direct admission,
              management quota, or NRI quota, our team ensures that you’re fully
              supported at every step.
            </div>
            <div>
              Our proven track record, transparent process, and deep college
              network make us the preferred choice for MBA aspirants across
              India.
            </div>
          </div>

          <div className="mt-5">
            <hr className="mb-2" />

            <b>Ready to begin your MBA journey?</b>
            <p>
              {" "}
              Connect with Counselling India today and let our expert MBA
              admissions consultants help you take the next step toward a
              successful future.{" "}
            </p>
          </div>

          <div className="mt-[50px]">
            <h2>FAQ’S</h2>

            <h6 className="mt-6">
              ❓ FAQ 1: Who is an MBA Admissions Consultant?
            </h6>
            <p>
              An MBA Admissions Consultant is a professional or an agency that
              helps students and working professionals plan, prepare, and secure
              admission into top MBA programs. The role of an MBA Admissions
              Consultant goes beyond just filling out application forms. They
              guide you on choosing the right B-schools based on your profile,
              entrance exam scores, career goals, and budget. A good MBA
              Admissions Consultant assists with entrance exam strategies, essay
              writing, SOPs (Statement of Purpose), Letters of Recommendation
              (LORs), mock interviews, and even management quota seats if
              needed. Many students choose an MBA Admissions Consultant to avoid
              mistakes in applications, meet tight deadlines, and get insider
              insights about colleges. In today’s competitive scenario, an
              experienced MBA Admissions Consultant can boost your chances of
              getting into your dream B-school by providing personalized advice,
              real-time updates about deadlines, and valuable mentorship
              throughout the admission cycle.
            </p>
            <h6 className="mt-5">
              ❓ FAQ 2: Why should I hire an MBA Admissions Consultant?
            </h6>
            <p>
              Hiring an MBA Admissions Consultant can make a huge difference in
              your MBA journey. Most students get overwhelmed with college
              shortlisting, entrance exams, multiple rounds of applications, and
              interviews. An MBA Admissions Consultant acts like a mentor who
              helps you plan your timeline, prepare competitive applications,
              and avoid common errors that may cost you a seat. A professional
              MBA Admissions Consultant knows the specific requirements of
              different colleges and can help craft impressive SOPs and essays
              that reflect your strengths. They also conduct mock interviews,
              which are very useful to boost your confidence. Many reputed
              consultants also help students explore management quota seats in
              top private colleges if their scores are below cut-offs. Working
              with an MBA Admissions Consultant saves time, reduces stress, and
              increases your chances of securing admission in the first attempt.
              Think of an MBA Admissions Consultant as an investment for your
              future career.
            </p>
            <h6 className="mt-5">
              ❓ FAQ 3: What services does an MBA Admissions Consultant offer?
            </h6>
            <p>
              A professional MBA Admissions Consultant provides a wide range of
              services to make your admission process smooth. They begin with
              profile evaluation, where they understand your academic
              background, work experience, career goals, and target colleges.
              Next, an MBA Admissions Consultant helps you shortlist the right
              B-schools that match your goals and budget. They guide you on
              entrance exam preparation strategies for exams like CAT, XAT,
              GMAT, or SNAP. A major part of an MBA Admissions Consultant’s role
              is assisting you with SOPs, essays, and LORs, making sure your
              application stands out. They also provide mock interviews, GD/PI
              preparation, and tips to handle stress during selection rounds.
              Some MBA Admissions Consultants even help you explore options like
              direct admission through management quota if needed. From
              documentation support to deadline reminders, an MBA Admissions
              Consultant stays with you throughout the journey till you get your
              admission letter.
            </p>
            <h6 className="mt-5">
              ❓ FAQ 4: How do I choose the best MBA Admissions Consultant?
            </h6>
            <p>
              Choosing the right MBA Admissions Consultant is crucial. Start by
              checking their track record — how many students have they helped,
              and which colleges did those students get into? Read reviews and
              testimonials on Google, LinkedIn, or trusted forums. A good MBA
              Admissions Consultant should offer a clear plan of action,
              transparent fee structure, and no fake guarantees. Always look for
              consultants who have strong networks with top B-schools and
              up-to-date knowledge of admission trends. The best MBA Admissions
              Consultant will listen to your goals, customize their services to
              fit your profile, and stay available throughout the cycle. Avoid
              agents who promise guaranteed admission without merit or demand
              full payment upfront without receipts. Ask for a clear written
              agreement outlining services included. A trustworthy MBA
              Admissions Consultant will guide you honestly, share realistic
              options, and keep you informed at every stage.
            </p>
            <h6 className="mt-5">
              ❓ FAQ 5: How much does an MBA Admissions Consultant charge?
            </h6>
            <p>
              The fees for an MBA Admissions Consultant vary based on the
              consultant’s reputation, range of services, and the colleges
              you’re targeting. Some consultants charge a fixed package for the
              entire admission cycle, while others charge per service like SOP
              writing or mock interviews. On average, an MBA Admissions
              Consultant may charge anywhere from ₹20,000 to ₹1 lakh or more,
              depending on the complexity of your application and the number of
              colleges you’re applying to. For international MBA programs,
              consultants may charge higher due to the extensive paperwork and
              visa guidance involved. It’s always wise to clarify all charges
              upfront. A genuine MBA Admissions Consultant will provide you with
              a clear breakdown of fees and payment milestones. Remember, while
              cost matters, what’s more important is the consultant’s
              credibility, success record, and the value they add to your MBA
              journey.
            </p>
            <h6 className="mt-5">
              ❓ FAQ 6: Can an MBA Admissions Consultant help with low entrance
              scores?
            </h6>
            <p>
              Yes, an experienced MBA Admissions Consultant can guide students
              with lower entrance exam scores to secure seats through
              alternative pathways like management quota or colleges with
              flexible cut-offs. They help you shortlist institutes that match
              your profile and scores realistically. A good MBA Admissions
              Consultant can also suggest retaking exams, applying to multiple
              entrance tests, or exploring colleges that accept scores from
              different exams like MAT or CMAT. Some students with lower scores
              still secure top colleges by strengthening their application with
              strong SOPs, work experience, and impressive interviews — an MBA
              Admissions Consultant helps with all this. For students who want
              to explore MBA Admission Through Management Quota, a trusted
              consultant can connect you with genuine college admission offices,
              explain the fee structure, and handle documentation. So even with
              low scores, an MBA Admissions Consultant ensures you have a fair
              chance to pursue your MBA dream.
            </p>
            <h6 className="mt-5">
              ❓ FAQ 7: Will an MBA Admissions Consultant guarantee admission?
            </h6>
            <p>
              No genuine MBA Admissions Consultant will ever guarantee admission
              because final selection depends on multiple factors — your
              academic record, entrance scores, interview performance, and seat
              availability. However, a professional MBA Admissions Consultant
              does significantly increase your chances by helping you present a
              strong application, prepare for interviews, and explore multiple
              colleges that fit your profile. Be cautious of agents who promise
              100% guaranteed admission in exchange for high fees without any
              proper documentation — these are often scams. A trusted MBA
              Admissions Consultant will guide you honestly about your chances,
              suggest backup options, and keep your expectations realistic.
              They’ll also help you with alternative routes like management
              quota admissions or lesser-known but reputable institutes if top
              colleges are out of reach. So, while no consultant can promise
              guaranteed results, the right MBA Admissions Consultant can make
              your MBA admission process stress-free and far more successful.
            </p>
            <h6 className="mt-5">
              ❓ FAQ 8: How early should I hire an MBA Admissions Consultant?
            </h6>
            <p>
              It’s best to hire an MBA Admissions Consultant at least 6–12
              months before your target MBA intake. For example, if you’re
              planning for MBA Admission 2026, you should start working with an
              MBA Admissions Consultant by mid-2026. Early guidance helps you
              plan your entrance exam prep, build your profile with internships
              or certifications, and draft strong SOPs and essays. Many students
              approach an MBA Admissions Consultant only after their entrance
              results, but by then, deadlines are often tight, and options may
              be limited. Starting early means you can also apply for multiple
              entrance exams, attend coaching if needed, and shortlist backup
              colleges. An MBA Admissions Consultant can help you map out a
              clear timeline so you don’t miss any critical dates. So, the
              sooner you begin, the better your chances of securing admission in
              your dream college with the help of a trusted MBA Admissions
              Consultant.
            </p>
            <h6 className="mt-5">
              ❓ FAQ 9: Do I need an MBA Admissions Consultant for overseas MBA
              programs?
            </h6>
            <p>
              Yes, hiring an MBA Admissions Consultant is very useful for
              students planning to pursue an MBA abroad. International B-schools
              have complex admission processes involving GMAT/GRE scores,
              TOEFL/IELTS scores, multiple essays, SOPs, LORs, and visa
              documentation. An expert MBA Admissions Consultant can help you
              shortlist the right global B-schools based on your profile,
              country preferences, budget, and work experience. They assist with
              crafting strong essays that showcase your leadership skills,
              career goals, and personal story — all critical for top global
              programs. Additionally, an MBA Admissions Consultant prepares you
              for Skype/virtual interviews and helps you navigate visa and
              scholarship applications. Applying for an international MBA
              without expert guidance can be overwhelming and risky. That’s why
              many students trust an MBA Admissions Consultant to maximize their
              chances of getting into top B-schools in the US, UK, Canada,
              Singapore, or Europe.
            </p>
            <h6 className="mt-5">
              ❓ FAQ 10: How do I verify if an MBA Admissions Consultant is
              genuine?
            </h6>
            <p>
              To ensure you choose a genuine MBA Admissions Consultant, do
              thorough research before committing. Start by checking their
              website, office address, and contact details. Read student reviews
              and success stories on platforms like Google, Trustpilot, or
              LinkedIn. A reliable MBA Admissions Consultant will never promise
              fake guarantees or ask for large upfront payments without clear
              receipts. Always ask for a written agreement that explains what
              services they’ll provide. Check if they have partnerships with
              reputed B-schools or a network of alumni. It’s also a good idea to
              talk to students who’ve used their services before. Be cautious of
              anyone offering admission letters without entrance exams or
              official college communication — that’s a red flag. A trusted MBA
              Admissions Consultant will always be transparent, answer your
              questions clearly, and keep you informed at every step of your MBA
              journey.
            </p>
          </div>
        </Container>
      </section>

      {/* instruction section start  */}

      {/* top college details start*/}

      {/* enquiry form section start */}
      <m.section
        className="py-[160px] bg-cover 	bg-no-repeat overflow-hidden relative bg-center lg:py-[120px] md:py-[95px] xs:py-[80px] xxs:py-[50px]"
        style={{
          backgroundImage:
            "url(/assets/img/webp/MedicalCounsellingIndia/home/enquiry/enquiry.webp)",
        }}
        {...fadeIn}
      >
        <Container className="xs:px-0">
          <div className="flex justify-center mb-[100px] w-full">
            <p className="font-normal text-[20px] w-[70%] lg:w-[70%] md:w-[100%] text-center">
              Get Top Education Consultant in Jamshedpur. Kindly submit your
              data below and we shall connect you as soon as possible.
            </p>
          </div>
          <Row className="justify-end md:justify-center">
            <Col xl={7} lg={7} md={9} sm={11}>
              <div className="px-[3rem] py-[5rem] rounded-md shadow-[0_0_30px_rgb(0,0,0,0.08)] bg-white sm:p-20 xs:rounded-none xs:px-[3.5rem] xs:py-[6rem]">
                <span className="mb-[15px] font-medium text-center text-[#f78c1f] text-md font-serif uppercase block sm:mb-[10px]">
                  Submit your details here
                </span>
                <h5 className="w-[80%] mb-[40px] font-bold text-center	tracking-[-1px] text-black font-serif uppercase mx-auto xs:w-full">
                  YOU ARE JUST A CALL AWAY
                </h5>

                <form className="mb-[30px]" onSubmit={handleSubmit(onSubmit)}>
                  <m.div
                    className="row justify-center"
                    {...{ ...fadeIn, transition: { delay: 0.6 } }}
                  >
                    <Col xl={6} lg={6} md={6} sm={12}>
                      <div className="mb-[33px]">
                        <input
                          type="text"
                          name="name"
                          className="rounded-[5px] relative py-[13px] px-[20px]  w-full border-[1px] border-solid border-[#dfdfdf] overflow-hidden"
                          placeholder="Your name"
                          {...register("name", {
                            required: {
                              value: true,
                              message: "Name is required",
                            },
                          })}
                        />
                        <div className="absolute text-[tomato] text-[12px] translate-y-[-3px] translate-x-[10px]">
                          {errors.name?.message}
                        </div>
                      </div>
                    </Col>
                    <Col xl={6} lg={6} md={6} sm={12}>
                      <div className="mb-[33px]">
                        <input
                          type="text"
                          name="email"
                          className="rounded-[5px] py-[13px] px-[20px]  w-full border-[1px] border-solid border-[#dfdfdf] overflow-hidden"
                          placeholder="Your email address"
                          {...register("email", {
                            required: {
                              value: true,
                              message: "Email is required.",
                            },
                            pattern: {
                              value:
                                /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
                              message: "Enter valid email",
                            },
                          })}
                        />
                        <div className="absolute text-[tomato] text-[12px] translate-y-[-3px] translate-x-[10px]">
                          {errors.email?.message}
                        </div>
                      </div>
                    </Col>
                    <Col xl={6} lg={6} md={6} sm={12}>
                      <div className="mb-[33px]">
                        <input
                          type="number"
                          name="phone"
                          className="rounded-[5px] py-[13px] px-[20px]  w-full border-[1px] border-solid border-[#dfdfdf] overflow-hidden"
                          placeholder="Your phone number"
                          onKeyDown={handleKeyDown}
                          {...register("phone", {
                            required: {
                              value: true,
                              message: "Phone number is required",
                            },
                            pattern: {
                              value:
                                /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/,
                              message: "Enter valid phone number",
                            },
                          })}
                        />
                        <div className="absolute text-[tomato] text-[12px] translate-y-[-3px] translate-x-[10px]">
                          {errors.phone?.message}
                        </div>
                      </div>
                    </Col>
                    <Col xl={6} lg={6} md={6} sm={12}>
                      <div className="mb-[33px]">
                        <input
                          type="text"
                          name="address"
                          className="rounded-[5px] py-[13px] px-[20px]  w-full border-[1px] border-solid border-[#dfdfdf] overflow-hidden"
                          placeholder="Your address"
                          {...register("address", {
                            required: {
                              value: true,
                              message: "Address is required",
                            },
                          })}
                        />
                        <div className="absolute text-[tomato] text-[12px] translate-y-[-3px] translate-x-[10px]">
                          {errors.address?.message}
                        </div>
                      </div>
                    </Col>
                    <Col xl={12} lg={12} md={12} sm={12}>
                      <div className="mb-[33px]">
                        <input
                          type="text"
                          name="stream"
                          className="rounded-[5px] py-[13px] px-[20px] w-full border-[1px] border-solid border-[#dfdfdf] overflow-hidden"
                          placeholder="Subject"
                          {...register("stream", {
                            required: {
                              value: true,
                              message: "Stream is required",
                            },
                            value: "Subject",
                          })}
                        />
                        <div className="absolute text-[tomato] text-[12px] translate-y-[-3px] translate-x-[10px]">
                          {errors.stream?.message}
                        </div>
                      </div>
                    </Col>
                    <Col xl={12} lg={12} md={12} sm={12}>
                      <div className="mb-[33px]">
                        <textarea
                          type="text"
                          rows={3}
                          name="message"
                          className="rounded-[5px] py-[13px] px-[20px]  w-full border-[1px] border-solid border-[#dfdfdf] overflow-hidden"
                          placeholder="Your message"
                          {...register("message", {
                            required: {
                              value: true,
                              message: "Message is required",
                            },
                          })}
                        />
                        <div className="absolute text-[tomato] text-[12px] translate-y-[-10px] translate-x-[10px]">
                          {errors.message?.message}
                        </div>
                      </div>
                    </Col>
                  </m.div>

                  <Buttons
                    type="submit"
                    className={`btn-fill text-sm leading-none font-medium tracking-[1px] !py-[17px] px-[32px] rounded-[4px] w-full uppercase mb-[5px] ${
                      formLoading ? "loading" : ""
                    }`}
                    themeColor="#f78c1f"
                    color="#fff"
                    size="lg"
                    title="Request a call schedule"
                  />
                </form>
              </div>
            </Col>
          </Row>
        </Container>
        <ToastContainer />
      </m.section>
      {/* enquiry form section end */}
    </>
  );
}

export default MbaAdmissionCounsellingIndia;
